import React from "react";
import { Menu, MenuItem, ListItemIcon, Divider } from "@mui/material";
import {
  AccountCircle as AccountCircleIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { ProfileMenuProps } from "../types/admin";

const ProfileMenu: React.FC<ProfileMenuProps> = ({
  anchorEl,
  open,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      onClick={onClose}
      PaperProps={{
        sx: {
          borderRadius: 0,
          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
          border: "1px solid #e5e7eb",
          background: "#ffffff",
        },
      }}
    >
      <MenuItem>
        <ListItemIcon>
          <AccountCircleIcon fontSize="small" />
        </ListItemIcon>
        {t("admin.profile.profile")}
      </MenuItem>
      <MenuItem>
        <ListItemIcon>
          <SettingsIcon fontSize="small" />
        </ListItemIcon>
        {t("admin.profile.settings")}
      </MenuItem>
      <Divider />
      <MenuItem>{t("admin.profile.logout")}</MenuItem>
    </Menu>
  );
};

export default ProfileMenu;
